module.exports = __webpack_public_path__ + "static/media/1006303.78b6d437.png";